export const REGEX_CURRENCY_DOLLAR = /([1-9]{1}[0-9]{0,}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|\.[0-9]{1,2})$/gm;

export const REGEX_CURRENCY_DOLLAR_REPLACE = /[^0-9.]+/g;

export const REGEX_NUMBERS_ONLY_REPLACE = /[^0-9]/g;
